export const selectedRoles = ['ADMIN', 'NATIONAL HEAD', 'NH'];

export const modulesForOtherRoles = [{ name: 'Dashboard' }, { name: 'Employees' }, { name: 'Lead' }, { name: 'Order' }, {name: 'Vendors'}];
